import React from "react";
import { Card, Table, Badge, Container, Row, Col } from "react-bootstrap";

const AdminReports = () => {
    const salesData = {
        totalRevenue: "$50,000",
        totalOrders: 120,
        topProduct: "Singer 2025",
    };

    const orderSummary = [
        { id: 1, date: "2025-02-20", customer: "John Doe", amount: "$500", status: "Completed" },
        { id: 2, date: "2025-02-21", customer: "Jane Smith", amount: "$350", status: "Pending" },
        { id: 3, date: "2025-02-22", customer: "Michael Lee", amount: "$700", status: "Completed" },
    ];

    const topSellingProducts = [
        { id: 1, name: "Singer 2025", sales: 45 },
        { id: 2, name: "Brother XM2701", sales: 38 },
        { id: 3, name: "Janome HD3000", sales: 30 },
    ];

    return (
        <Container className="py-4">
            <h2 className="text-center fw-bold mb-4">📊 Reports & Analytics</h2>

            {/* Sales Overview Cards */}
            <Row className="mb-4">
                <Col md={4}>
                    <Card className="text-center shadow-sm p-3">
                        <h4 className="fw-semibold">Total Revenue</h4>
                        <p className="display-6 text-success">{salesData.totalRevenue}</p>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="text-center shadow-sm p-3">
                        <h4 className="fw-semibold">Total Orders</h4>
                        <p className="display-6 text-primary">{salesData.totalOrders}</p>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="text-center shadow-sm p-3">
                        <h4 className="fw-semibold">Top Product</h4>
                        <p className="h4 text-warning">{salesData.topProduct}</p>
                    </Card>
                </Col>
            </Row>

            {/* Order Summary Table */}
            <Card className="p-3 shadow-sm mb-4">
                <h4 className="fw-semibold mb-3">📦 Recent Orders</h4>
                <Table striped bordered hover responsive>
                    <thead className="table-dark">
                        <tr>
                            <th>Date</th>
                            <th>Customer</th>
                            <th>Amount</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orderSummary.map(order => (
                            <tr key={order.id}>
                                <td>{order.date}</td>
                                <td>{order.customer}</td>
                                <td>{order.amount}</td>
                                <td>
                                    <Badge bg={order.status === "Completed" ? "success" : "warning"}>{order.status}</Badge>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card>

            {/* Top Selling Products Table */}
            <Card className="p-3 shadow-sm mb-4">
                <h4 className="fw-semibold mb-3">🔥 Top-Selling Products</h4>
                <Table striped bordered hover responsive>
                    <thead className="table-dark">
                        <tr>
                            <th>Product Name</th>
                            <th>Units Sold</th>
                        </tr>
                    </thead>
                    <tbody>
                        {topSellingProducts.map(product => (
                            <tr key={product.id}>
                                <td>{product.name}</td>
                                <td className="text-center fw-bold text-primary">{product.sales}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card>

            {/* Placeholder for Future Graphs */}
            <Card className="p-4 text-center shadow-sm">
                <h4 className="fw-semibold mb-2">📈 Sales Graph (Coming Soon)</h4>
                <div className="d-flex justify-content-center align-items-center border border-2 border-secondary rounded-3" style={{ width: "150px", height: "150px", margin: "auto" }}>
                    <span className="text-muted">Graph Here</span>
                </div>
            </Card>
        </Container>
    );
};

export default AdminReports;
